<ac-map [sceneMode]="sceneMode" class="globe" fxFlexFill>
    <app-maps-provider></app-maps-provider>
    <app-area-provider></app-area-provider>
    <app-points-provider></app-points-provider>
    <app-toolbar-provider></app-toolbar-provider>
    <app-point-info-provider></app-point-info-provider>
    <app-polygon-info-provider></app-polygon-info-provider>
</ac-map>
